<script>

export default {
  props:{
    title: String,
    dataSource: {type: Array, default: null},
    icon: String,
    type: Number
  },
  emits: ["click-btn","click-gift-detail"],
  data(){
    return{
        btnStatus:{
            0: '领取',
            1: '周一打卡可领取',
            3: '周三打卡可领取',
            5: '周五打卡可领取',
            7: '周日打卡可领取',
            9: '已领取',
        },
    }
  }
};
</script>

<template>
  <div
    :class="$style.giftItemComponent"
    :style="{
      backgroundImage: `url(//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_btWeekSignIn/giftBg.png)`,
    }"
  >
    <h3 :class="$style.giftType">{{ title }}</h3>
    <img
      :class="$style.giftIcon"
      :src="`//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_btWeekSignIn/${icon}.png`"
    />
    <h4 :class="$style.giftName">{{ dataSource ? dataSource[0].giftName :''}}</h4>
    <p :class="$style.giftDetail"  @click="$emit('click-gift-detail', dataSource)">
      {{ dataSource ? dataSource[0].giftDetail:'' }}
    </p>
    <div :class="$style.giftButton" @click="$emit('click-btn', dataSource, type)" 
      :style="`filter: ${dataSource && dataSource[0].giftState === 9 ? 'grayscale(1)': 'none'};`">
      {{dataSource? btnStatus[dataSource[0].giftState] : '' }}
    </div>
  </div>
</template>

<style lang="scss" module>
.giftItemComponent {
  margin-top: 12px;
  width: 48%;
  height: 195px;
  background-size: 100% 100%;
  text-align: center;
  .giftType {
    font-size: 16.67px;
    font-weight: 700;
    text-align: center;
    color: #833d13;
    height: 30px;
    line-height: 30px;
  }
  .giftIcon {
    width: 80px;
  }
  .giftName {
    color: #833d13;
  }
  .giftDetail {
    position: relative;
    width: 100%;
    height: 26px;
    line-height: 13px;
    overflow: hidden; //溢出内容隐藏
    text-overflow: ellipsis; //文本溢出部分用省略号表示
    color: #9f5829;
    font-size: 12px;
    display: -webkit-box; //特别显示模式
    -webkit-line-clamp: 2; //行数
    -webkit-box-orient: vertical;
    line-clamp: 2;
    margin-top: 1px;
  }
  .giftButton {
    width: 90%;
    padding: 6px;
    background: #ffb017;
    border-radius: 12.15px;
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    margin: 6px auto 0;
  }
}
</style>
